<div class="card-vehicle-modal-title {{language}}">
    <div class="mb-0 gb-headline2" role="heading" aria-level="2">
        <span [translate]="'activeVehicle_updateMileageTitle'"></span>
    </div>
    <button class="close-modal" (click)="dismissUpdateModal()" aria-hidden="false"
        attr.aria-label="{{'aoda_close_modal_label' | translate }}">
        <span aria-hidden="true" class="icon-ui-closedot gb-body1"></span>
    </button>
    <hr>
</div>

<!-- ERROR ALERT:UPDATE MILEAGE  -->
<div [hidden]="!showUpdateMileageError">
    <div class="row">
        <div class="col-12">
            <div class="alert alert-danger">
                <span aria-hidden="true" class="icon-ui-attention"></span>
                <div class="card-body-alert danger">
                    <p class="gb-body1" [translate]="'activeVehicle_invalidUpdateMileageError'"></p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ERROR ALERT:INVALID MILEAGE  -->
<div [hidden]="!invalidMileageError">
    <div class="row">
        <div class="col-12">
            <div class="alert alert-danger">
                <span yaria-hidden="true" class="icon-ui-attention"></span>
                <div class="card-body-alert danger">
                    <p class="gb-body1" [translate]="'activeVehicle_invalidMileageError'"></p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="{{language}}" gm-track-link="UpdateMileage:TextBox:EnterMileage" track-delay="true" track-type="o"
    prop10="update mileage:textBox:enter mileage" [formGroup]="updateMileageForm">
    <ox-text-input [formGroupInput]="updateMileageForm" [formControlNameInput]="'updateMileageInput'" [inputName]="'odometer'"
        [classes]="'form-control'" [submitted]="false" [required]="'true'"
        [pattern]="'odometerAttributes.pattern.source'" [validationType]="'odometer'"
        [maxLength]="odometerAttributes.maxlength" [id]="'updateMileageInput'"
        [attr.aria-labelledby]="'updateMileageInput'" [label]="'activeVehicle_addVehicleMileage_mileageLabel'">
    </ox-text-input>

    <button type="submit" class="gb-primary-button col-4 mt-4" (click)="updateMileage()"
        gm-track-link="UpdateMileage:UpdateMileage" track-delay="true" track-type="o"
        prop10="update mileage:button:save" attr.aria-label="{{'activeVehicle_saveMileageBtn' | translate }}">
        <span [translate]="'activeVehicle_saveMileageBtn'"></span>
    </button>
</div>

<!-- Confirmation Modal -->
<ox-general-modal 
    [(show)]="showConfirmationModal" 
    [options]="confirmationModalStyling"
    [bodyComponent]="confirmationModal" 
    [bindingInputs]="confirmationInputs" 
    [bindingOutputs]="confirmationOutputs">
</ox-general-modal>
